import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Jornada() {
  const { id } = useParams();
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [faseSel, setFaseSel] = useState(0);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(null);
  const [pulando, setPulando] = useState(false);
  const [marcando, setMarcando] = useState(false);
  const [editObs, setEditObs] = useState(null); // tarefa_id editando
  const [textoObs, setTextoObs] = useState('');
  const [showBot, setShowBot] = useState(false);
  const [showNCM, setShowNCM] = useState(false);
  const [showFornecedores, setShowFornecedores] = useState(false);
  const [ncmBusca, setNcmBusca] = useState('');
  const [ncmResultados, setNcmResultados] = useState([]);
  const [ncmLoading, setNcmLoading] = useState(false);
  const [fornList, setFornList] = useState([]);
  const [fornLoading, setFornLoading] = useState(false);
  const [botMsg, setBotMsg] = useState('');
  const [botHist, setBotHist] = useState([]);
  const [botLoading, setBotLoading] = useState(false);

  const load = useCallback(() => {
    api.get(`/operacoes/${id}/progresso`, token).then(d => { setData(d); setLoading(false); });
  }, [id, token]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (tarefaId) => {
    setToggling(tarefaId);
    await api.post(`/operacoes/${id}/tarefas/${tarefaId}/toggle`, {}, token);
    await load();
    setToggling(null);
  };

  const marcarTodas = async () => {
    setMarcando(true);
    const fase = data.fases[faseSel];
    const naoFeitas = fase.tarefas.filter(t => !t.concluido);
    for (const t of naoFeitas) {
      await api.post(`/operacoes/${id}/tarefas/${t.id}/toggle`, {}, token);
    }
    await load();
    setMarcando(false);
  };

  const desmarcarTodas = async () => {
    setMarcando(true);
    const fase = fasesComPulada[faseSel];
    const feitas = fase.tarefas.filter(t => t.concluido);
    for (const t of feitas) {
      await api.post(`/operacoes/${id}/tarefas/${t.id}/toggle`, {}, token);
    }
    await load();
    setMarcando(false);
  };

  const pularFase = async () => {
    setPulando(true);
    try {
      await api.post(`/operacoes/${id}/fases/${fase.id}/pular`, {}, token);
      await load();
      // Avançar automaticamente para próxima fase
      setFaseSel(prev => Math.min(prev + 1, fases.length - 1));
    } catch(e) { console.error(e); }
    setPulando(false);
  };

  const salvarObs = async (tarefaId) => {
    await api.post(`/operacoes/${id}/tarefas/${tarefaId}/observacao`, { observacao: textoObs }, token);
    setEditObs(null); setTextoObs('');
    await load();
  };

  const excluirObs = async (tarefaId) => {
    await api.post(`/operacoes/${id}/tarefas/${tarefaId}/observacao`, { observacao: '' }, token);
    await load();
  };

  const buscarNCM = async () => {
    if (ncmBusca.trim().length < 3) return;
    setNcmLoading(true);
    try {
      const resp = await api.get(`/ia/ncm/busca?q=${encodeURIComponent(ncmBusca)}`, token);
      setNcmResultados(resp);
    } catch(e) {} finally { setNcmLoading(false); }
  };

  const buscarFornecedores = async () => {
    setFornLoading(true);
    try {
      const resp = await api.get('/fornecedores?status=aprovado', token);
      setFornList(resp);
    } catch(e) {} finally { setFornLoading(false); }
  };

  const enviarBot = async () => {
    if (!botMsg.trim()) return;
    const msg = botMsg.trim();
    setBotMsg('');
    const novoHist = [...botHist, { role: 'user', content: msg }];
    setBotHist(novoHist);
    setBotLoading(true);
    try {
      const resp = await api.post('/ia/chat', { mensagem: msg, historico: botHist }, token);
      setBotHist([...novoHist, { role: 'assistant', content: resp.resposta }]);
    } catch(e) { setBotHist([...novoHist, { role: 'assistant', content: 'Erro ao conectar com o ImportBot.' }]); }
    setBotLoading(false);
  };

  if (loading) return <div style={{padding:32,color:'#6B7289'}}>Carregando jornada...</div>;

  const { operacao, fases, fasesPuladas = [] } = data;
  // Marcar fases puladas
  const fasesComPulada = fases.map(f => ({ ...f, pulada: fasesPuladas.map(Number).includes(Number(f.id)) }));
  const fase = fasesComPulada[faseSel];
  const feitas = fase.tarefas.filter(t => t.concluido).length;
  const total = fase.tarefas.length;
  const pct = Math.round(feitas / total * 100);
  const complete = pct === 100;
  const falta = total - feitas;
  const faseAnteriorCompleta = faseSel === 0 || (() => {
    const anterior = fases[faseSel - 1];
    return anterior.tarefas.filter(t=>t.concluido).length === anterior.tarefas.length || anterior.opcional;
  })();

  const totalGeral = fasesComPulada.reduce((s,f) => s + f.tarefas.length, 0);
  const feitasGeral = fasesComPulada.reduce((s,f) => s + f.tarefas.filter(t=>t.concluido).length, 0);
  const pctGeral = Math.round(feitasGeral / totalGeral * 100);

  return (
    <div style={{display:'grid',gridTemplateColumns:'240px 1fr',height:'calc(100vh - 0px)',overflow:'hidden',position:'relative'}}>
      {/* SIDEBAR FASES */}
      <div style={{background:'#F7F8FC',borderRight:'0.5px solid #E4E6EF',display:'flex',flexDirection:'column',overflow:'hidden'}}>
        <div style={{padding:'16px 14px',borderBottom:'0.5px solid #E4E6EF'}}>
          <div style={{fontSize:11,fontWeight:500,color:'#6B7289',marginBottom:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{operacao.nome}</div>
          <div style={{fontSize:20,fontWeight:700,letterSpacing:'-.02em'}}>{pctGeral}%</div>
          <div className="progress-bar" style={{marginTop:6}}><div className="progress-fill" style={{width:pctGeral+'%'}} /></div>
          <div style={{fontSize:10,color:'#6B7289',marginTop:5}}>{feitasGeral} de {totalGeral} tarefas</div>
        </div>
        <div style={{flex:1,overflowY:'auto',padding:'8px 0'}}>
          {fasesComPulada.map((f, i) => {
            const fc = f.tarefas.filter(t=>t.concluido).length;
            const ft = f.tarefas.length;
            const fp = Math.round(fc/ft*100);
            // Pulada e sem progresso manual = mostrar como 100%
            const efetivamentePulada = f.pulada && fc === 0;
            const nc = (fp===100 || efetivamentePulada)?'done':fc>0?'partial':'todo';
            const fpDisplay = efetivamentePulada ? 100 : fp;
            // Fase bloqueada se anterior não está completa E não foi pulada
            const anteriorFase = i > 0 ? fases[i-1] : null;
            const anteriorCompleta = i === 0 || 
              (anteriorFase && anteriorFase.tarefas.filter(t=>t.concluido).length === anteriorFase.tarefas.length) ||
              (anteriorFase && anteriorFase.pulada);
            const bloqueada = !anteriorCompleta && fc === 0;
            return (
              <div key={f.id} onClick={()=>!bloqueada&&setFaseSel(i)}
                style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',
                  cursor: bloqueada?'not-allowed':'pointer',
                  background: faseSel===i?'#fff':'transparent',
                  borderLeft: faseSel===i?'2px solid #1A2ECC':'2px solid transparent',
                  opacity: bloqueada?0.5:1,
                  transition:'.1s'}}>
                <div style={{width:26,height:26,borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700,flexShrink:0,
                  background: nc==='done'?'#E6F7F1':bloqueada?'#F1F2F5':nc==='partial'?'#EBF0FF':'#F1F2F5',
                  color: nc==='done'?'#0A6B47':bloqueada?'#9095A8':nc==='partial'?'#1028A0':'#9095A8'}}>
                  {bloqueada?'🔒':nc==='done'?'✓':f.id}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:11,fontWeight:faseSel===i?600:400,color:faseSel===i?'#0B0E1A':'#6B7289',lineHeight:1.3,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.nome}</div>
                  {f.opcional && <div style={{fontSize:9,color:'#E6A817',fontWeight:600}}>Opcional</div>}
                </div>
                <div style={{fontSize:10,fontWeight:600,color:nc==='done'?'#0FA36B':nc==='partial'?'#1A2ECC':'#9095A8',flexShrink:0}}>{fpDisplay}%</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* CONTEÚDO DA FASE */}
      <div style={{overflowY:'auto',padding:'28px 32px'}}>
        <div style={{marginBottom:20}}>
          <span style={{fontSize:10,fontWeight:600,color:'#1A2ECC',textTransform:'uppercase',letterSpacing:'.1em',background:'#EBF0FF',padding:'3px 10px',borderRadius:99}}>
            Fase {fase.id} de 8{fase.opcional?' · Opcional':''}
          </span>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10}}>
            <div style={{fontSize:20,fontWeight:700,letterSpacing:'-.02em'}}>{fase.nome}</div>
            {fase.opcional && !complete && (
              <button onClick={pularFase} disabled={pulando}
                style={{fontSize:12,fontWeight:600,color:'#E6A817',background:'#FEF5E4',border:'1px solid #F0D580',borderRadius:8,padding:'8px 14px',cursor:'pointer',opacity:pulando?0.6:1,flexShrink:0}}>
                {pulando ? 'Pulando...' : '⏭ Pular fase opcional'}
              </button>
            )}
          </div>
          <div style={{fontSize:13,color:'#6B7289',padding:'10px 14px',background:'#F7F8FC',borderRadius:8,borderLeft:'3px solid #1A2ECC',marginTop:10}}>{fase.objetivo}</div>
          {/* Botões de acesso rápido por fase */}


        </div>

        <div className="card" style={{display:'flex',alignItems:'center',gap:16,marginBottom:16,padding:14}}>
          <div style={{fontSize:22,fontWeight:700,color:complete?'#0FA36B':'#1A2ECC',minWidth:44}}>{pct}%</div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,color:'#6B7289',marginBottom:5}}>{complete?'Fase concluída!':falta+' tarefa'+(falta>1?'s':'')+' restante'+(falta>1?'s':'')}</div>
            <div className="progress-bar"><div className="progress-fill" style={{width:pct+'%',background:complete?'#0FA36B':'#1A2ECC'}} /></div>
          </div>
          <div style={{fontSize:11,color:'#6B7289'}}>{feitas}/{total}</div>
        </div>

        <div className="card" style={{padding:0,overflow:'hidden',marginBottom:16}}>
          <div style={{padding:'12px 18px',borderBottom:'0.5px solid #E4E6EF',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <span style={{fontSize:11,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.08em'}}>Tarefas</span>
            <div style={{display:'flex',gap:6}}>
              {!complete && (
                <button onClick={marcarTodas} disabled={marcando}
                  style={{fontSize:11,fontWeight:600,color:'#1A2ECC',background:'#EBF0FF',border:'none',borderRadius:6,padding:'5px 12px',cursor:'pointer',opacity:marcando?0.6:1}}>
                  {marcando ? '...' : '✓ Marcar todas'}
                </button>
              )}
              {feitas > 0 && (
                <button onClick={desmarcarTodas} disabled={marcando}
                  style={{fontSize:11,fontWeight:600,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'5px 12px',cursor:'pointer',opacity:marcando?0.6:1}}>
                  ✗ Desmarcar todas
                </button>
              )}
            </div>
          </div>
          {fase.tarefas.map((t) => (
            <div key={t.id} onClick={()=>toggle(t.id)}
              style={{display:'flex',alignItems:'center',gap:12,padding:'13px 18px',borderBottom:'0.5px solid #E4E6EF',cursor:toggling===t.id?'wait':'pointer',
                background: t.concluido?'#F6FBF8':'#fff',transition:'.1s'}}
              onMouseEnter={e=>!t.concluido&&(e.currentTarget.style.background='#FAFBFE')}
              onMouseLeave={e=>e.currentTarget.style.background=t.concluido?'#F6FBF8':'#fff'}>
              <div style={{width:20,height:20,borderRadius:6,border:t.concluido?'none':'1.5px solid #E4E6EF',background:t.concluido?'#0FA36B':'transparent',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'.15s'}}>
                {t.concluido && <svg width="11" height="11" viewBox="0 0 12 10" fill="none" stroke="#fff" strokeWidth="2.5"><polyline points="1,5 4,8 11,1"/></svg>}
              </div>
              <div style={{flex:1}} onClick={e=>e.stopPropagation()}>
                <span style={{fontSize:13,color:t.concluido?'#6B7289':'#0B0E1A',textDecoration:t.concluido?'line-through':'none'}}>
                  {toggling===t.id ? '...' : t.descricao}
                </span>
                {/* Observação */}
                {editObs === t.id ? (
                  <div style={{marginTop:6,display:'flex',gap:6,alignItems:'flex-start'}}>
                    <textarea value={textoObs} onChange={e=>setTextoObs(e.target.value)} rows={2}
                      style={{flex:1,fontSize:11,padding:'6px 8px',border:'1px solid #E6A817',borderRadius:6,resize:'none',outline:'none',fontFamily:'inherit'}}
                      placeholder="Digite sua observação..." autoFocus />
                    <div style={{display:'flex',flexDirection:'column',gap:4}}>
                      <button onClick={()=>salvarObs(t.id)} style={{background:'#0FA36B',color:'#fff',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,cursor:'pointer'}}>✓</button>
                      <button onClick={()=>setEditObs(null)} style={{background:'#F4F5F9',color:'#6B7289',border:'none',borderRadius:5,padding:'4px 8px',fontSize:11,cursor:'pointer'}}>✕</button>
                    </div>
                  </div>
                ) : (
                  <div style={{marginTop:4}}>
                    {t.observacao ? (
                      <div style={{display:'flex',alignItems:'flex-start',gap:6}}>
                        <div style={{flex:1,fontSize:11,color:'#8C5E00',background:'#FFFBEB',padding:'4px 8px',borderRadius:5,borderLeft:'2px solid #E6A817'}}>
                          📝 {t.observacao}
                        </div>
                        <button onClick={()=>{setEditObs(t.id);setTextoObs(t.observacao);}}
                          style={{background:'none',border:'none',fontSize:11,cursor:'pointer',color:'#9095A8',padding:'2px'}}>✏️</button>
                        <button onClick={()=>excluirObs(t.id)}
                          style={{background:'none',border:'none',fontSize:11,cursor:'pointer',color:'#9095A8',padding:'2px'}}>🗑️</button>
                      </div>
                    ) : (
                      <button onClick={()=>{setEditObs(t.id);setTextoObs('');}}
                        style={{fontSize:10,color:'#9095A8',background:'none',border:'none',cursor:'pointer',padding:'2px 0'}}>
                        + obs
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
          <div style={{display:'flex',alignItems:'center',gap:8,padding:'12px 18px',background:complete?'#E6F7F1':'#F7F8FC',fontSize:12,color:complete?'#0A6B47':'#6B7289',borderTop:'0.5px solid #E4E6EF'}}>
            {complete ? '✅ Fase concluída — mentor notificado.' : '🛡 Ao concluir todas as tarefas, o mentor recebe um aviso.'}
          </div>
        </div>

        <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
          {faseSel > 0 && (
            <button className="btn-ghost" onClick={()=>setFaseSel(faseSel-1)}>← Fase anterior</button>
          )}
          {faseSel < fases.length - 1 && (
            complete ? (
              <button className="btn-primary" onClick={()=>setFaseSel(faseSel+1)}>Próxima fase →</button>
            ) : (
              <div style={{display:'flex',alignItems:'center',gap:8,padding:'10px 14px',background:'#FEF5E4',border:'0.5px solid #F0D580',borderRadius:8,fontSize:12,color:'#5A4000'}}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#E6A817" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                Conclua as {falta} tarefa{falta>1?'s':''} restante{falta>1?'s':''} para avançar.
              </div>
            )
          )}

        </div>
      </div>

      {/* MODAL FORNECEDORES */}
      {showFornecedores && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:300}}
          onClick={e=>e.target===e.currentTarget&&setShowFornecedores(false)}>
          <div style={{background:'#fff',borderRadius:16,padding:24,width:600,maxHeight:'80vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,.15)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
              <div style={{fontSize:16,fontWeight:700}}>🤝 Fornecedores Aprovados</div>
              <button onClick={()=>setShowFornecedores(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#9095A8'}}>×</button>
            </div>
            {fornLoading && <div style={{textAlign:'center',padding:24,color:'#9095A8'}}>Carregando...</div>}
            {fornList.map(f=>(
              <div key={f.id} style={{padding:'12px 14px',border:'1px solid #E4E6EF',borderRadius:8,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                  <div style={{fontWeight:600,fontSize:13}}>{f.empresa}</div>
                  <span style={{fontSize:10,background:'#E6F7F1',color:'#0A6B47',padding:'2px 8px',borderRadius:99,fontWeight:600}}>Aprovado</span>
                </div>
                <div style={{fontSize:11,color:'#6B7289',marginTop:2}}>{f.segmento} · {[f.cidade,f.pais].filter(Boolean).join(', ')}</div>
                {f.principais_produtos&&<div style={{fontSize:11,color:'#3D4461',marginTop:4}}>{f.principais_produtos}</div>}
                {f.email&&<div style={{fontSize:11,color:'#1A2ECC',marginTop:4}}>✉️ {f.email}</div>}
              </div>
            ))}
            {fornList.length===0&&!fornLoading&&<div style={{fontSize:12,color:'#9095A8',textAlign:'center',padding:16}}>Nenhum fornecedor aprovado cadastrado</div>}
          </div>
        </div>
      )}

      {/* IMPORTBOT FLUTUANTE */}
      <div style={{position:'fixed',bottom:24,right:24,zIndex:200}}>
        {showBot && (
          <div style={{width:340,height:420,background:'#fff',borderRadius:16,boxShadow:'0 8px 32px rgba(0,0,0,.15)',display:'flex',flexDirection:'column',marginBottom:12,border:'1px solid #E4E6EF'}}>
            <div style={{padding:'12px 16px',borderBottom:'0.5px solid #E4E6EF',display:'flex',justifyContent:'space-between',alignItems:'center',background:'#0B0E1A',borderRadius:'16px 16px 0 0'}}>
              <div style={{fontSize:13,fontWeight:600,color:'#fff'}}>🤖 ImportBot — {fase.nome}</div>
              <button onClick={()=>setShowBot(false)} style={{background:'none',border:'none',color:'rgba(255,255,255,.6)',cursor:'pointer',fontSize:18}}>×</button>
            </div>
            <div style={{flex:1,overflowY:'auto',padding:12,display:'flex',flexDirection:'column',gap:8}}>
              {botHist.length===0 && <div style={{fontSize:12,color:'#9095A8',textAlign:'center',marginTop:20}}>Olá! Sou o ImportBot. Tire suas dúvidas sobre a {fase.nome}.</div>}
              {botHist.map((m,i)=>(
                <div key={i} style={{display:'flex',justifyContent:m.role==='user'?'flex-end':'flex-start'}}>
                  <div style={{maxWidth:'85%',padding:'8px 12px',borderRadius:m.role==='user'?'12px 12px 2px 12px':'12px 12px 12px 2px',
                    background:m.role==='user'?'#1A2ECC':'#F4F5F9',color:m.role==='user'?'#fff':'#0B0E1A',fontSize:12,lineHeight:1.5}}>
                    {m.content}
                  </div>
                </div>
              ))}
              {botLoading && <div style={{fontSize:12,color:'#9095A8'}}>Digitando...</div>}
            </div>
            <div style={{padding:10,borderTop:'0.5px solid #E4E6EF',display:'flex',gap:8}}>
              <input value={botMsg} onChange={e=>setBotMsg(e.target.value)}
                onKeyDown={e=>e.key==='Enter'&&enviarBot()}
                placeholder="Sua dúvida..."
                style={{flex:1,padding:'8px 12px',border:'1px solid #E4E6EF',borderRadius:8,fontSize:12,outline:'none'}} />
              <button onClick={enviarBot} style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'8px 14px',fontSize:12,cursor:'pointer'}}>→</button>
            </div>
          </div>
        )}
        <button onClick={()=>setShowBot(!showBot)}
          style={{width:52,height:52,borderRadius:'50%',background:'#1A2ECC',color:'#fff',border:'none',fontSize:22,cursor:'pointer',boxShadow:'0 4px 16px rgba(26,46,204,.4)',display:'flex',alignItems:'center',justifyContent:'center'}}>
          🤖
        </button>
      </div>
    </div>
  );
}
